<template>
  <div class="w-full flex flex-col justify-start items-start relative">
    <nav :class="[$address?'pt-8':'pt-20 ']" class="w-full h-full sm:hidden block px-4 bg-gradient-to-b from-limed-spruce-900 to-transparent pb-8">
      <NuxtLink to="/app">
        <button class="bg-turquoise-500/20 border-turquoise-900 text-turquoise-500 shadow-xl rounded-full btn btn-circle btn-sm mb-4">
          <Icon name="mdi:arrow-left"></Icon>
        </button>
      </NuxtLink>

      <div>
        <h1 class="text-3xl font-light text-white">Calendar</h1>
        <p>Oxbull Calendar - Information at a glance</p>
      </div>
    </nav>

    <div oncontextmenu="return false;" oncopy="return false" oncut="return false" onpaste="return false" class="w-full relative">
      <div :class="[pinCalendar?'sticky top-0 sm:top-0':'sm:h-[24rem]']" class="unselectable  sm:flex sm:flex-col sm:justify-center sm:items-center w-full bg-woodsmoke-850">

        <div v-if="!$address" class="w-full bg-woodsmoke-700 p-2 pl-4 flex justify-between items-center sm:absolute fixed top-0 left-0 z-50">
          <p>Connect a wallet with sufficient tier to unlock complete information</p>

          <WalletModal>
            <button class="btn btn-sm bg-turquoise-600 text-black hover:text-white border-none">Connect Wallet</button>
          </WalletModal>
        </div>

          <div class=" px-4 pb-4 w-full duration-300 border-b border-b-white/30" :class="[initialized ? '' : 'hidden']">

            <div class="w-full flex justify-between px-1 py-1 items-center">
              <p class="text-turquoise-500">Oxbull Calendar</p>
          <button @click="pinCalendar =!pinCalendar" class="btn bg-white/10 btn-sm text-turquoise-500">{{  pinCalendar ? 'unpin':'pin' }}</button>
        </div>
        <ClientOnly v-if="$calendar?.attributes?.length > 0">
            <VCalendar ref="calendarRef" color="turqoise" :columns="columns" :is-dark="true" transparent expanded title-position="left" :attributes="$calendar?.attributes">
              <template #day-popover="{ date, dayTitle, attributes }">
                <div class="px-2">
                  <div class="text-xs text-gray-700 dark:text-gray-300 font-semibold text-center">
                    {{ dayTitle }}
                  </div>
                  <ul class="divide-y divide-white/20">
                    <li v-for="{ key, customData } in attributes" :key="key" class="block text-base p-2">
                      <div class="w-[250px] grid grid-cols-[32px_1fr] justify-center items-center gap-2">
                        <div class="w-[32px] h-[32px] rounded-lg ring ring-woodsmoke-400 p-0.5">
                          <NuxtImg width="32" height="32" quality="50" class="rounded-md" :src="customData.project_icon" alt="" />
                        </div>
                        <div>
                          <p class="text-sm font-light">{{ customData.title }}</p>
                          <p class="text-sm font-bold underline">{{ customData.event_title }}</p>
                          <!-- {{ customData }} -->
                        </div>

                        <div class="col-span-full" v-if="customData?.from_only">
                          <div class="text-sm mb-0.5 text-woodsmoke-100 inline-flex items-center justify-start">
                            <div class="p-0.5 px-1 bg-woodsmoke-600 text-white rounded-md">starts</div>
                            &nbsp;{{ formatDate(customData.start, customData?.from_format) }}
                          </div>
                        </div>
                        <div v-else class="col-span-full">
                          <div class="text-sm mb-0.5 text-woodsmoke-100 inline-flex items-center justify-start">
                            <div class="p-0.5 px-1 bg-woodsmoke-600 text-white rounded-md">starts</div>
                            &nbsp;{{ formatDate(customData.start, customData?.from_format) }}
                          </div>

                          <div class="text-sm text-woodsmoke-100 inline-flex items-center justify-start">
                            <div class="p-0.5 px-1 bg-woodsmoke-600 text-white rounded-md">ends</div>
                            &nbsp;{{ formatDate(customData.end, customData?.to_format) }}
                          </div>
                        </div>
                        <!-- <div>
                                    {{ date }}
                                </div> -->
                        <!-- <div class="text-sm">
                                    {{ customData.event_slug }}
                                </div> -->
                      </div>
                    </li>
                  </ul>
                </div>
              </template>
            </VCalendar>
          </ClientOnly>
          </div>


        <div class="px-4 w-full" v-if="!initialized">
          <div class="w-full h-[15rem] rounded-md border border-white/5 bg-white/5 skeleton"></div>
        </div>
      </div>

      <div class="w-full border-t border-t-woodsmoke-700/50 p-4">
        <div v-if="$calendar?.projects?.length > 0" class="w-full grid grid-cols-[repeat(auto-fill,minmax(300px,1fr))] gap-4">
          <template v-if="initialized">
            <template v-for="project in $calendar?.projects">
              <CalendarProject @gotoDate="gotoDate" v-if="project.show" :project="project" :isPermitted="$calendar?.isPermitted" :address="$address"></CalendarProject>
            </template>

            <template v-if="$calendar?.projects?.length == 0">
              <div class="w-full h-36 flex justify-center items-center col-span-full flex-col">
                <p>No data</p>
                <p class="text-sm text-woodsmoke-100">Check Telegram Group for latest news</p>
              </div>
            </template>
          </template>

          <template v-else>
            <!-- <div class="w-full h-48 col-span-full flex justify-center items-center">
            <span class="iconify text-4xl text-white" data-icon="eos-icons:loading"></span>
          </div> -->
            <div v-for="i in 6" class="w-full aspect-[3/4] bg-woodsmoke-800/20 rounded-md p-4 hover:bg-woodsmoke-800/50 border border-woodsmoke-400/20 hover:border-woodsmoke-400 transition-all duration-200 skeleton"></div>
          </template>
        </div>
      </div>

      <div class="w-full h-20"></div>

      <HeadlessTransitionRoot as="template" :show="showPnCModal">
        <HeadlessDialog as="div" class="relative z-50" @close="showPnCModal = false">
          <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
            <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </HeadlessTransitionChild>

          <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
            <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
              <HeadlessTransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
                <HeadlessDialogPanel class="relative transform overflow-hidden rounded-lg bg-woodsmoke-850 px-4 pb-4 pt-5 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:p-6">
                  <div>
                    <div class="flex justify-center items-center flex-col">
                      <!-- <div class="bg-yellow-500 text-black px-4 pt-1 text-sm uppercase tracking-widest font-bold pb-0.5 rounded-md">warning</div> -->
                      <p class="text-2xl text-white font-light mt-4">Strictly Confidential</p>
                      <p class="">For Your Eyes Only</p>
                    </div>

                    <!-- <p class="text-sm">You are about to access sensitive information that is intended for your use only. This information is provided to you based on trust and your authorization to view it. Please observe the following guidelines:</p> -->

                    <div class="w-full bg-yellow-500/5 border border-yellow-500/50 rounded-lg p-2 my-4 text-center">
                      <p class="sm:text-lg text-yellow-500 text-sm text-light">
                        <strong class="text-base">Read and understand the rules.</strong>
                        <br />
                        Breaching the rules will result in immediate, non-negotionable
                        <strong class="p-1 px-2 bg-yellow-500 rounded-md text-black uppercase">disqualification</strong>
                        &nbsp;.
                      </p>
                    </div>

                    <div class="w-full grid sm:grid-cols-2 grid-cols-2 sm:gap-4 gap-2">
                      <div class="w-full bg-white/5 p-2 rounded-md">
                        <div class="w-full sm:flex-row flex-col flex justify-start sm:items-center items-start sm:mb-4">
                          <span class="iconify text-xl mr-3 text-turquoise-300" data-icon="mdi:secure"></span>
                          <h6 class="text-turquoise-500 text-sm">Confidential</h6>
                        </div>
                        <p class="col-span-4 text-sm">The information you are about to view is confidential. It is your responsibility to maintain its secrecy.</p>
                      </div>

                      <div class="w-full bg-white/5 p-2 rounded-md">
                        <div class="w-full sm:flex-row flex-col flex justify-start sm:items-center items-start sm:mb-4">
                          <span class="iconify text-xl mr-3 text-turquoise-300" data-icon="mdi:share-off"></span>
                          <h6 class="text-turquoise-500 text-sm">No Share</h6>
                        </div>
                        <p class="col-span-4 text-sm">Strictly prohibited from sharing, distributing, or discussing this information with unauthorized individuals.</p>
                      </div>

                      <div class="w-full bg-white/5 p-2 rounded-md">
                        <div class="w-full sm:flex-row flex-col flex justify-start sm:items-center items-start sm:mb-4">
                          <span class="iconify text-xl mr-3 text-turquoise-300" data-icon="fa6-solid:handshake-simple"></span>
                          <h6 class="text-turquoise-500 text-sm">Be Responsible</h6>
                        </div>
                        <p class="col-span-4 text-sm">Your access to this information is a testament to the trust we place in you. Breach of this trust, will lead to disqualification.</p>
                      </div>

                      <div class="w-full bg-white/5 p-2 rounded-md">
                        <div class="w-full sm:flex-row flex-col flex justify-start sm:items-center items-start sm:mb-4">
                          <span class="iconify text-xl mr-3 text-turquoise-300" data-icon="icon-park-solid:report"></span>
                          <h6 class="text-turquoise-500 text-sm">Report Breach</h6>
                        </div>
                        <p class="col-span-4 text-sm">Be vigilant in protecting this information. Report any suspected breach or security lapse immediately.</p>
                      </div>
                    </div>
                  </div>

                  <div class="mt-5 sm:mt-6">
                    <button type="button" class="inline-flex w-full justify-center rounded-md bg-turquoise-500 px-3 py-2 text-sm font-semibold text-turquoise-900 shadow-sm hover:bg-black hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2" @click="showPnCModal = false">Agree and view</button>
                  </div>
                </HeadlessDialogPanel>
              </HeadlessTransitionChild>
            </div>
          </div>
        </HeadlessDialog>
      </HeadlessTransitionRoot>

      <div v-if="$calendar?.isPermitted" class="w-full fixed sm:bottom-0 top-14 sm:top-auto left-0 sm:border-t sm:border-t-white/50 flex justify-center items-center" style="background: repeating-linear-gradient(-55deg, #222, #222 10px, #333 10px, #333 20px)">
        <ClientOnly>
          <vue3-seamless-scroll :step="0.25" direction="left" :single-line="true" :list="confidentialList" class="w-full overflow-hidden">
            <div class="sm:w-[100vw] w-[200vw] whitespace-nowrap text-sm flex justify-center items-center" v-for="i in confidentialList" :key="i">
              <div class="p-1.5 text-yellow-500 animate-pulse uppercase">Information displayed here are Private and Confidential, please do not redistribute further.</div>
            </div>
          </vue3-seamless-scroll>
        </ClientOnly>

        <button @click="showPnCModal = true" class="w-6 h-6 btn m-0 p-0 min-h-0 btn-circle absolute right-1 bottom-1 bg-white shadow-xl hover:text-white text-black">
          <!-- <span class="iconify text-xl" data-icon="memory:help"></span> -->
          <Icon name="memory:help" class="text-xl"></Icon>
        </button>
      </div>

    </div>
    <div v-if="$address"  class="fixed top-0 left-0" >
      <Watermark :watertext="$address"></Watermark>
    </div>

  </div>
</template>

<script setup>
definePageMeta({
  layout: "app",
  name: "calendar",
});

useHead({
  title: 'Oxbull | Calendar',
  meta: [
    { name: 'title', content: "Oxbull | Calendar" },
    { name: 'description', content: "Monitor Oxbull.Tech initiatives through our organized calendar for seamless project tracking." }
  ],
  htmlAttrs: { lang: "en" }
})

import { Vue3SeamlessScroll } from "vue3-seamless-scroll";

import { useUserStore } from "~/stores/user.js";
const userStore = useUserStore();

// import { config } from "~/wagmiConfig.js";
import { getAccount, watchAccount, watchConnections } from "@wagmi/core";

const { $address, $accessToken, $calendar, $userData, $renderCalendar } = useNuxtApp()

// const address = ref("");
const pinCalendar = ref(false)



// const unwatch = watchConnections(config, {
//   onChange(data) {
//     if (data) {
//       let _account = getAccount(config);
//       address.value = _account.address;
//     } else {
//       address.value = null;
//     }
//     renderCalendar();
//   },
// });

// const unwatchAccount = watchAccount(config, {
//   onChange(data) {
//     renderCalendar();
//   },
// });

// const unsub = userStore.$subscribe((state) => {
//   renderCalendar();
// });

// onUnmounted(() => {
//   unwatch();
//   unsub();
//   unwatchAccount()
// });

// watch($address, () => {
//   renderCalendar();
// });

// watch($accessToken, () => {
//   renderCalendar();
// });

// onMounted(() => {
//   renderCalendar();
//   // address.value = getAccount(config).address;
// });

const calendarRef = ref(null);


////

// import { createClient } from "@supabase/supabase-js";
// const supabase = createClient("https://ukfztwboozjkcxaclima.supabase.co", "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InVrZnp0d2Jvb3pqa2N4YWNsaW1hIiwicm9sZSI6ImFub24iLCJpYXQiOjE2ODM2MDg0ODcsImV4cCI6MTk5OTE4NDQ4N30.15MQeuuQKzj-i4BgcMIDY30_pcx4qqw0feulCQREwIE");

import { useScreens } from "vue-screen-utils";

import {formatDate} from '~/module/calendar.js'

// const accountData = ref({});
// const attributes = ref([]); // calendar dates are stored here
const initialized = ref(true); // this is to show the loading spinner
// const projects = ref([]); // this is the list of projects
const showPnCModal = ref(false); // Private and Confidential modal flag
const isPermitted = ref(false)

/// Just a simple list to store the confidential text
let confidentialList = [];
for (let i = 0; i < 5; i++) {
  confidentialList.push("confidential");
}

const { mapCurrent } = useScreens({
  xs: "0px",
  sm: "640px",
  md: "768px",
  lg: "1024px",
});
const columns = mapCurrent({
  xs: 1,
  sm: 2,
  md: 2,
  lg: 2,
});

onMounted( () => {

  watch( $userData, () => {
    $renderCalendar()
  })

  watch( $accessToken, () => {
    $renderCalendar()
  })

  watch( $address, () => {
    $renderCalendar()
  })

  watch(calendarRef, () => {
    if(calendarRef.value){
      calendarRef.value.focusDate(new Date());
    }
  });

  let calendar_warning = localStorage.getItem("calendar_warning_2");
  let now_plus_60 = new Date().getTime() + 60 * 60 * 1000;

        if (!calendar_warning) {
        showPnCModal.value = true;
        localStorage.setItem("calendar_warning_2", now_plus_60);
      } else {
        /// check if current time is greater than the stored time

        if (new Date().getTime() > calendar_warning) {
          showPnCModal.value = true;
          localStorage.setItem("calendar_warning_2", now_plus_60);
        }
      }
})

// update callback from the calendar module
const update = (args) => {
  // console.log(args);
  // let { projects: _projects, isPermitted:_isPermitted, attributes:_attributes } = args;
  // projects.value = _projects;
  // isPermitted.value = _isPermitted;
  // attributes.value = _attributes;
  

  // if(!initialized.value){
  //   initialized.value = true;
  // }

  // let calendar_warning = localStorage.getItem("calendar_warning_2");
  //     let now_plus_60 = new Date().getTime() + 60 * 60 * 1000;

  //     if (!calendar_warning) {
  //       showPnCModal.value = true;
  //       localStorage.setItem("calendar_warning_2", now_plus_60);
  //     } else {
  //       /// check if current time is greater than the stored time

  //       if (new Date().getTime() > calendar_warning) {
  //         showPnCModal.value = true;
  //         localStorage.setItem("calendar_warning_2", now_plus_60);
  //       }
  //     }
}

// authState callback for the calendar module, to get current user's address and authentication status
// const authState = () => {
//   return {
//     authenticated: $accessToken.value ? true : false,
//     address: $address.value
//   }
// }

// const _calendar = new Calendar({
//   update: update,
//   authState: authState,
// });

// let throttle = null;

// const renderCalendar = () => {
//   if(throttle){
//     clearTimeout(throttle);
//   }

//   throttle = setTimeout(() => {
//     _calendar.render();
//   }, 100);
// }

const gotoDate = (_unix) => {
  if (calendarRef.value) {
    let _date = new Date(_unix * 1000);
    calendarRef.value.focusDate(_date);
  }
};

// const isPermitted = () => {
//   if (address.value == "0x39E03e34Ca304D135D0e413B364B0dF65542c7B1") return true; // sigmud wallet address
//   if (accountData?.value?.pspInfo) {
//     if (accountData?.value?.pspInfo?.isOxbTier1 || accountData?.value?.pspInfo?.isKwaiTier1 || accountData?.value?.pspInfo?.oxbPsp?.isPsp || accountData?.value?.pspInfo?.kwaiPsp?.isPsp) {
//       // showPnCModal

//       // check localStorage if user has seen the modal for this hour
//       // localStorage.getItem("calendar_warning") if this is null or undefined, then we show the modal
//       // and set localStorage.setItem("calendar_warning_2", <unix timestamp>)
//       // if it's not null, then we check if the current unix timestamp is greater than the stored unix timestamp
//       // stored unix timestamp is the date of last time + 60 minutes

//       let calendar_warning = localStorage.getItem("calendar_warning_2");
//       let now_plus_60 = new Date().getTime() + 60 * 60 * 1000;

//       if (!calendar_warning) {
//         showPnCModal.value = true;
//         localStorage.setItem("calendar_warning_2", now_plus_60);
//       } else {
//         /// check if current time is greater than the stored time

//         if (new Date().getTime() > calendar_warning) {
//           showPnCModal.value = true;
//           localStorage.setItem("calendar_warning_2", now_plus_60);
//         }
//       }

//       return true;
//     }

//     return false;
//   } else {
//     return false;
//   }
// };

// const updateAttributes = () => {
//   // sort by project.sequence
//   projects.value = projects.value.sort((a, b) => {
//     return b.sequence - a.sequence;
//   });

//   /// we need to sort the project's dates item by start

//   // console.log(projects.value);

//       // remove projects thare hidden
//   projects.value = projects.value.filter((_p) => {
//     return _p.show;
//   });

//   for (let _project of projects.value) {
//     if (!_project.dates) continue;
//     _project.dates = _project.dates.sort((a, b) => {
//       return b.from_unix - a.from_unix;
//     });

//     /// check date's accesibility
//     /// if date.private is true, then we check if the user is eligible using isPermitted function
//     /// if user is not eligible, then we remove the date from the array

//     // console.log(_project.dates);
//     _project.dates = _project.dates.filter((date) => {
//       if (date.private) {
//         if (!isPermitted()) {
//           return false;
//         }
//       }
//       return true;
//     });
//   }

//   attributes.value = [
//     ...projects.value
//       .filter((project) => project.dates)
//       .flatMap((project) => {
//         let _attr = [];
//         for (let date of project.dates) {

//           // if date has both from_unix and to_unix, then we should set it 
//           // otherwise, we use the from_unix as both start and end

//           let _dates = {}
//           let _customData = {}

//           if (date?.from_unix && date?.to_unix) {
//             _dates = {
//               start: new Date(date.from_unix * 1000), // Start of the range
//               end: new Date(date.to_unix * 1000), // End of the range
//             }

//             _customData = {
//               event_title: date.title,
//               start: date.from_unix * 1000,
//               end: date.to_unix * 1000,
//               ...project,
//             }
//           }

//           else if (date?.from_unix) {
//             _dates = {
//               start: new Date(date.from_unix * 1000), // Start of the range
//               end: new Date(date.from_unix * 1000), // End of the range
//             }

//             _customData = {
//               event_title: date.title,
//               start: date.from_unix * 1000,
//               end: date.from_unix * 1000,
//               show_from_date_only: date?.show_from_date_only,
//               ...project,
//             }
//           }


//           _attr.push({
//             // key: `project-${project.id}`,
//             highlight: {
//               start: { fillMode: "light", color: date.color },
//               base: { fillMode: "light", color: date.color },
//               end: { fillMode: "light", color: date.color },
//             },
//             dates: _dates,
//             dot: {
//               color: date.color,
//             },
//             content: "Event",
//             popover: {
//               visibility: "hover",
//             },
//             customData: _customData,
//           });
//         }

//         return _attr;
//       }),
//   ];

//   // console.clear();
//   // console.log(attributes.value);
// };

// let calendarThrottle = false;

// const renderCalendar = async () => {

//   let _renderCalendar = async () => {

//   // if(!userStore.authenticated){
//   //   return
//   // }

//   /// Steps:
//   /// 0. Fetch the user account data
//   /// 1. Setup a subscription to the database
//   /// 2. Fetch the database once

//   if (userStore.authenticated) {
//     let gqlResult = await queryNoCache(
//       gql`
//         query User($limit: Int, $after: Int) {
//           user(limit: $limit, after: $after) {
//             tiers
//             pspInfo {
//               isOxbTier1
//               isKwaiTier1
//               oxbPsp {
//                 isPsp
//               }
//               kwaiPsp {
//                 isPsp
//               }
//             }
//           }
//         }
//       `,
//       {
//         limit: 6,
//         after: null,
//       }
//     );

//     accountData.value = gqlResult["user"];
//   } else {
//     accountData.value = {};
//   }

//   const _main = () => {
//     supabase
//       .from("exclusive_board")
//       .select("*")
//       .then(({ data, error }) => {
//         if (error) {
//           console.log(error);
//         } else {
//           /// we shall hide exclusive events for user who are not eligible

//           if (data) {
//             projects.value = data.filter((item) => {
//               if (!accountData?.value && !item.show_tier_none) {
//                 return false;
//               }

//               if (accountData?.value?.tiers == "NONE" && !item.show_tier_none) {
//                 return false;
//               }

//               if (accountData?.value?.tiers == "BSC_T1" && !item.show_tier_one) {
//                 return false;
//               }

//               if (accountData?.value?.tiers == "BSC_T2" && !item.show_tier_two) {
//                 return false;
//               }

//               if (accountData?.value?.tiers == "BSC_T3" && !item.show_tier_three) {
//                 return false;
//               }

//               if (item.is_private) {
//                 if (!isPermitted()) {
//                   return false;
//                 }

//                 /// Add new checks, granular checks for
//                 // show_tier_one
//                 // show_tier_two
//                 // show_tier_three
//                 // we translate user's tiers, use if else
//               }
//               return true;
//             });
//           }

//           // projects.value = data;
//           initialized.value = true;
//         }

//         updateAttributes();

//         // console.clear();
//         // console.log(data);
//       });
//   };

//   const channel = supabase
//     .channel("exclusive_board")
//     .on(
//       "postgres_changes",
//       {
//         event: "*",
//         schema: "public",
//       },
//       (payload) => {
//         //replace the old value in projects, with payload.new's value, if the id matches
//         _main();
//       }
//     )
//     .subscribe();

//   // fetch the database once
//   _main();
//   }

//   if (calendarThrottle) {
//     clearTimeout(calendarThrottle);
//   }

//   calendarThrottle = setTimeout(_renderCalendar, 100);
// };

// const formatDate = (unix_ts, _format) => {
//   // Convert the start Unix timestamp to a JavaScript Date object in UTC timezone
//   const time = new Date(unix_ts); // Multiply by 1000 to convert to milliseconds
//   const parsedTime = parseISO(time.toISOString());
//   // const isoDate = startDate.toISOString()
//   // console.clear();
//   // console.log(parsedTime);
//   // Format the start date as "dd MMM yyyy HHmm UTC"
//   // const formattedDate = format(isoDate, "dd MMM yyyy HHmm 'UTC'");
//   let _fmt
//   if(!_format){
//     _fmt = "dd MMM yyyy HHmm 'UTC'"
//   }
//   const formatInTimeZone = (date, fmt, tz) => format(utcToZonedTime(date, tz), fmt, { timeZone: tz });

//   const formattedTime = formatInTimeZone(parsedTime, _fmt , "UTC");

//   return formattedTime;
// };
</script>

<style>

</style>
